import { render, staticRenderFns } from "./DSSubstrate.vue?vue&type=template&id=435082ab&scoped=true&"
import script from "./DSSubstrate.vue?vue&type=script&lang=ts&"
export * from "./DSSubstrate.vue?vue&type=script&lang=ts&"
import style0 from "./DSSubstrate.vue?vue&type=style&index=0&id=435082ab&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435082ab",
  null
  
)

export default component.exports